// You can write more code here

import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import {
  getBiomeFromStudentLevel,
  waitUntil,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class MentorUI extends Phaser.GameObjects.Image {
  constructor(
    scene: Phaser.Scene,
    x?: number,
    y?: number,
    texture?: string,
    frame?: number | string,
  ) {
    super(scene, x ?? 0, y ?? 0, texture || 'npc_mentor_e_portrait', frame);

    this.scaleX = 0.3;
    this.scaleY = 0.3;

    /* START-USER-CTR-CODE */

    this.setMentorFromPlayerBiome(getBiomeFromStudentLevel(getStudent().level));
    this.texture.setFilter(Phaser.Textures.LINEAR);
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  async setMentorFromPlayerBiome(biome: number) {
    let textureKey = '';
    switch (biome) {
      case 0:
      default:
        textureKey = 'npc_mentor_e_portrait';
        break;
      case 1:
        textureKey = 'npc_mentor_b_portrait';
        break;
      case 2:
        textureKey = 'npc_mentor_a_portrait';
        break;
      case 3:
        textureKey = 'npc_mentor_d_portrait';
        break;
      case 4:
        textureKey = 'npc_mentor_c_portrait';
        break;
    }
    if (!this.scene.textures.exists(textureKey)) {
      this.setVisible(false);
      await this.loadMentorTexture(textureKey);
    }
    this.setVisible(true);
    this.setTexture(textureKey);
  }

  async loadMentorTexture(textureKey: string) {
    this.scene.load.image(
      textureKey,
      `game_assets/sprites/phaser_game/npcs/${textureKey}.png`,
    );
    this.scene.load.start();
    await waitUntil(this.scene.time, () =>
      this.scene.textures.exists(textureKey),
    );
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
